export type BrowserName = 'edge' | 'chrome' | 'safari' | 'firefox' | 'other';

/**
 * Which desktop browser this is, for pointing at its own settings. Phones and
 * the smaller Chromium browsers keep their settings elsewhere, so they get the
 * generic steps rather than wrong ones.
 */
export function browserName(userAgent: string): BrowserName {
  if (/Android|iPhone|iPad|Mobile/.test(userAgent)) {
    return 'other';
  }
  if (/Edg\//.test(userAgent)) {
    return 'edge';
  }
  if (/Firefox\//.test(userAgent)) {
    return 'firefox';
  }
  if (/OPR\/|Vivaldi\/|YaBrowser\//.test(userAgent)) {
    return 'other';
  }
  if (/Chrome\//.test(userAgent)) {
    return 'chrome';
  }
  if (/Version\/[\d.]+.*Safari\//.test(userAgent)) {
    return 'safari';
  }
  return 'other';
}
